import React from 'react';
import { useTranslation } from 'react-i18next';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
var BlockedSubscribedMiddleContent = function (_a) {
    var thumbWidth = _a.thumbWidth, thumbHeight = _a.thumbHeight, className = _a.className;
    var t = useTranslation().t;
    var canShowDescription = thumbHeight && thumbHeight > 200 && thumbWidth && thumbWidth > 280;
    var isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    if (isUnreasonablySmall) {
        return (React.createElement(HoverOnly, { reverseHidden: true },
            React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-tier", size: "large" }), className: className })));
    }
    return (React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-tier", size: "large" }), subtitle: canShowDescription
            ? t('deviationview.overlay.subscriber.locked')
            : undefined, className: className }));
};
BlockedSubscribedMiddleContent.displayName = 'BlockedSubscribedMiddleContent';
export default BlockedSubscribedMiddleContent;
//# sourceMappingURL=BlockedSubscribedMiddleContent.js.map